<template>
  <div id="page-container" class="fade">
    <div class="login login-with-news-feed">
      <div class="container-bs">
        <div class="row">
          <div class="col-md-6 col-md-offset-3">
            <div class="login-header">
              <div class="brand">
                <img
                  src="../assets/img/flapper-logo.png"
                  data-id="login-cover-image"
                  alt
                  height="60"
                />
                Backoffice
              </div>
            </div>

            <div class="login-content" v-if="step == 'login'">
              <v-wp-form @submit="handleForm" class="margin-bottom-0">
                <v-form-group class="m-b-15">
                  <v-old-input
                    alias="e-mail"
                    validation-config="required|email"
                    placeholder="Email Address"
                    class="input-lg"
                    type="text"
                    name="emailAddress"
                    v-model="emailAddress"
                  />
                </v-form-group>

                <v-form-group class="m-b-15">
                  <v-old-input
                    name="password"
                    validation-config="required"
                    placeholder="Password"
                    class="input-lg"
                    type="password"
                    v-model="password"
                  />
                </v-form-group>

                <p class="text-danger" v-if="errorMessage != null">
                  {{ errorMessage }}
                </p>
                <p class="text-left">
                  Forgot your password?
                  <a href="#" @click="step = 'forgot-password'">Click here!</a>
                </p>
                <div class="checkbox m-b-30">
                  <label> <input type="checkbox" /> Remember Me </label>
                </div>
                <div class="login-buttons">
                  <button
                    type="submit"
                    class="btn btn-success btn-block btn-lg"
                  >
                    Sign me in
                  </button>
                </div>
                <hr />
              </v-wp-form>
            </div>

            <div class="login-content" v-if="step == 'forgot-password'">
              <FormForgotPassword />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import "../assets/plugins/bootstrap/css/bootstrap.min.css";
@import "../assets/css/style.css";
.input-lg {
  height: 40px;
}
body {
  background: #fff !important;
}
.center-content {
  width: 500px;
  margin-left: auto;
  margin-right: auto;
}
</style>

<script>
import axios from "axios";
import FormForgotPassword from "../components/Forms/Base/ForgotPassword.vue";
export default {
  components: {
    FormForgotPassword
  },

  data() {
    return {
      step: "login",
      emailAddress: "",
      password: "",
      errorMessage: null
    };
  },

  mounted() {
    this.$el.classList.add("in");
    var loader = document.getElementById("page-loader");
    if (loader != null) loader.remove();
  },

  methods: {
    handleForm(event) {
      this.errorMessage = null;

      event.preventDefault();
      axios
        .post("/api/operator/signin", {
          emailAddress: this.emailAddress,
          password: this.password
        })
        .then(response => {

          const {
            data: {
              data: { confirmed, emailAddress } = {}
            } = {}
          } = response;

          const confirmedFlag = Number(confirmed);
          window.localStorage.setItem("isConfirmed", confirmedFlag);
          window.localStorage.setItem("emailAddress", emailAddress ?? "");

          if (confirmedFlag) {
            window.location.href = "/";
          } else {
            window.location.href = "/changepassword";
          }

        })
        .catch(reason => {
          this.errorMessage = reason.getResultDescription();
        });
    }
  }
};
</script>
